import DescBlock from "./descBlock";

export default DescBlock;
